import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import '../../styles/MenuPageNew.scss';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Header from '../common/Header';
import Section from './Section';
import AllergensList from './AllergensList';
import LandingPage from '../common/LandingPage';
import Arrow from '../common/Arrow';
import Footer from '../common/Footer';
import { isBeer } from '../common/utils';
import { Helmet } from 'react-helmet-async';

const MenuPage = () => {
  const [menuSections, setMenuSections] = useState([]);
  const [isOpen, setIsOpen] = useState([]);
  const [selectedAllergens, setSelectedAllergens] = useState([]);
  const [loading, setLoading] = useState(true);

  const toggleMenu = (id) => {
    if (isOpen.includes(id)) {
      setIsOpen(isOpen.filter(i => i !== id));
    } else {
      setIsOpen([...isOpen, id]);
    }
  };

  const toggleAllergen = (allergen) => {
    setSelectedAllergens(prevSelected => 
      prevSelected.includes(allergen) 
      ? prevSelected.filter(a => a !== allergen) 
      : [...prevSelected, allergen]
    );
  };

  useEffect(() => {
    const fetchMenuSections = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'sections'));
        const sections = {};
        
        snapshot.forEach(doc => {
          const data = doc.data();
          const section = data.name;
          sections[section] = sections[section] || [];
          sections[section].push({
            id: doc.id,
            ...data,
            items: data.items.map(item => (
              isBeer(section) ? { ...item, prices: item.prices || [], imageUrl: item.imageUrl || '' } : item
            ))
          });
        });

        const orderedMenuSections = Object.keys(sections).sort((a, b) => sections[a][0].order - sections[b][0].order)
        .map(section => {
          const sectionItems = sections[section][0].items.map(item => {
            if (item.burgers) {
              return {
                ...item,
                burgers: item.burgers.filter(burger =>
                  !selectedAllergens.some(allergen => burger.allergens?.includes(allergen))
                )
              };
            } else {
              return !selectedAllergens.some(allergen => item.allergens?.includes(allergen)) ? item : null;
            }
          }).filter(item => item); 
      
          return {
            sectionName: section,
            items: sectionItems,
            subtitle: sections[section][0].subtitle,
            id: sections[section][0].id
          };
        });
        setMenuSections(orderedMenuSections);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching menu items:', error);
      }
    };

    fetchMenuSections();
  }, [selectedAllergens]); // Effettua il fetch quando cambiano gli allergeni selezionati

  return (
    loading ? 
    <LandingPage /> :
    <div>
      <Helmet>
        <title>Menu - CosyHole</title>
        <meta name="description" content="Pizzeria Birreria CosyHole - Scopri il nostro menù ricco di pizze deliziose e birre artigianali. Vieni a gustare i sapori autentici preparati con ingredienti freschi e di alta qualità." />
      </Helmet>
      <Header className='beer-header'>
        <div className='header-child menu-title'>
          <h1 data-aos="fade-right">Menù</h1>
          <p data-aos="fade-up">Scopri il nostro menù ricco di pizze deliziose e birre artigianali. Vieni a gustare i sapori autentici preparati con ingredienti freschi e di alta qualità.</p>
          <Arrow data-aos="fade-up" direction="down" size="small" animated={true}/>
        </div>
      </Header>
      <div className="menu-page">
          {menuSections.map(section => (
            (section.items?.length || section.wineries?.length) > 0 && (
              <div key={section.sectionName} className="menu-section">
                <div className="section-header" onClick={() => toggleMenu(section.id)} >
                  <div className="section-header-content">
                    <h3>{section.sectionName}</h3>
                  </div>
                  <div 
                    style={{'background-image': `url('${section.sectionName}.jpg')`}}
                    className={"more-icon " + (isOpen.includes(section.id) ? "" : "_collapsed")}>
                    <ExpandMoreIcon className={(isOpen.includes(section.id) ? "" : "_collapsed")} />
                  </div>
                </div>
                <Section isOpen={isOpen} section={section}></Section>
              </div>
            )
          ))}
        </div>
        <AllergensList selectedAllergens={selectedAllergens} onAllergenToggle={toggleAllergen} />
        <Footer />
    </div>
  );
};

export default MenuPage;
